import React from 'react'
import { Locale, isLocale } from '../../types/locale'

const STORAGE_KEY = 'locale'
const DEFAULT_LOCALE: Locale = 'fi-FI'

// Legacy short-form locales stored before the switch to BCP-47 tags (fi-FI/sv-SE).
const LEGACY_LOCALE_MAP: Record<string, Locale> = {
  fi: 'fi-FI',
  sv: 'sv-SE',
}

export const getStoredLocale = (): Locale => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (isLocale(stored)) return stored
    if (stored && stored in LEGACY_LOCALE_MAP) return LEGACY_LOCALE_MAP[stored]
    return DEFAULT_LOCALE
  } catch {
    return DEFAULT_LOCALE
  }
}

export const setStoredLocale = (locale: Locale): void => {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // localStorage unavailable (e.g. private browsing) - locale choice won't persist
  }
}

export interface LocaleContextValue {
  locale: Locale
  setLocale: (locale: Locale) => void
}

export const LocaleContext = React.createContext<LocaleContextValue>({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
})
